module.exports = __webpack_public_path__ + "img/loading.c7cc6686.gif";